import { handleAction, handleActions } from 'redux-actions';
import { selectReason } from './actions';
const initialState = { title: null, docs: [] };
const handleSelectReason = handleAction(selectReason, (state, { payload }) => {
    return payload;
}, initialState);
export default handleActions({
    [selectReason.toString()]: handleSelectReason
}, initialState);
